import ComplateIcon from "../images/complate.gif";
import LoadingIcon from "../images/loading.gif";
import FailIcon from "../images/fail.png";
import { FunctionComponent } from "react";

type FetchingType = {
  iconType: string;
  text: string;
};

export const Fetching: FunctionComponent<FetchingType> = ({
  iconType,
  text,
}) => {
  const Icon =
    iconType === "Fail"
      ? FailIcon
      : iconType === "Complate"
      ? ComplateIcon
      : LoadingIcon;

  return (
    <div className="flex items-center ease-in-out ">
      <div className="flex flex-col px-20 py-10 bg-white rounded-xl drop-shadow-xl items-center">
        <img className="w-[60px]" src={Icon} alt="Loading"></img>
        <div className="font-semibold text-xl">{text}</div>
      </div>
    </div>
  );
};
